import { Check } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import { IMaterial } from '../../interfaces';
import { ImportFormSection } from './ImportFormSection';


export interface IMaterialImportDialog {
    onImported: (materials: IMaterial[]) => void
}

export const MaterialImportDialog: React.SFC<IMaterialImportDialog> = ({ onImported }) => {

    const onClose = () => {

        if (complete)
            onImported(complete);

        setOpen(false);
    }

    const handleImportComplete = (materials: IMaterial[]) => {
        setComplete(materials);
    }

    const [open, setOpen] = useState(false);
    const [complete, setComplete] = useState<IMaterial[]>();

    return (
        <span>
            <Tooltip title="Import Materials">


                <Button sx={{ mb: 1, mr: 1 }} variant="outlined" size="small" color="info" onClick={() => setOpen(true)} >Import</Button>

            </Tooltip>

            <Dialog
                open={open}
                onClose={onClose}
                fullWidth
            >
                <DialogTitle>
                    Material Import
                </DialogTitle>
                <DialogContent>

                    {complete ?
                        <p><Check /> Import complete. {complete.length} materials were updated.</p>
                        :
                        <>
                            <p>Select a csv to upload. The import will begin automatically.</p>

                            <ImportFormSection
                                onImported={handleImportComplete}
                            />
                        </>

                    }



                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </span>
    );
}